import { z } from "zod";

export type NameOnly = z.infer<typeof NameOnlySchema>;
export const NameOnlySchema = z.object({
  name: z.string(),
});
